import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PlayCircle } from 'lucide-react'
import Footer from '@/components/Footer'
import ParaEmpresasNavbar from '@/components/ParaEmpresasNavbar'
import { COMERCIAL_WHATSAPP_LINK, getDemoLead } from '@/lib/demoLead'

const ParaEmpresasDemo = () => {
  const navigate = useNavigate()
  const lead = getDemoLead()

  useEffect(() => {
    if (!lead) {
      navigate('/para-empresas', { replace: true })
    }
  }, [lead, navigate])

  if (!lead) {
    return null
  }

  return (
    <div className="min-h-screen bg-background">
      <ParaEmpresasNavbar />

      <section className="pt-32 pb-20">
        <div className="container max-w-3xl mx-auto text-center space-y-6">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground">
            Bem-vindo(a), {lead.nome.split(' ')[0]}
          </h1>
          <p className="text-muted-foreground">
            Aqui está um episódio de demonstração da plataforma AI Sym.
          </p>

          <div className="aspect-video bg-card border border-dashed border-border rounded-xl flex flex-col items-center justify-center gap-3 text-muted-foreground">
            <PlayCircle className="w-12 h-12 text-primary" />
            <p className="text-sm">[PLACEHOLDER] Vídeo do episódio de demonstração</p>
          </div>

          <a
            href={COMERCIAL_WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center gap-2 text-sm px-6 py-3"
          >
            Falar com especialista
          </a>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default ParaEmpresasDemo
